<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="余额管理"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<!--            有id时候 静态页面数据-->
			<el-form-item label="手机号码">
				<el-select v-model="item.mobile" filterable placeholder="请选择">
					<el-option v-for="item in options" :key="item.id" :label="item.mobile" :value="item.mobile">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="类型">
				<el-radio v-model="type" label="1">增加</el-radio>
				<el-radio v-model="type" label="2">减少</el-radio>
			</el-form-item>
			<el-form-item label="金额">
				<el-input v-model="item.riches" placeholder="请输入金额"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				options: [],
				dialogVisible: false,
				type: "1",
				rules: {

				}
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			async loadData() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				let res = ''
				// 获取手机号码
				res = await this.axios.post('/store/member/list', {
					page: 1,
					limit: 10000
				})
				this.options = res.data.records
				this.isLoad = !this.isLoad
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.item.type = this.type
				let url = '/store/memberRiches/add'
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
